/**
 * Ops UI auth store. Thin wrapper over `createAuthStore` from
 * `@nova-integration/ui-shared`. Importing `../lib/capabilities` is required to
 * register ops-ui's role -> capability map with the shared registry before any
 * `can(...)` checks are issued.
 *
 * The identity URL is resolved by the shared store via `getAppUrl('identity')`,
 * which prefers `window.__NOVA_ENV__.identityUrl` (BFF-injected at request time)
 * and falls back to `REACT_APP_IDENTITY_URL` in dev. We deliberately do NOT
 * pass an `identityUrl` here so the same image works in any cluster.
 */
import '../lib/capabilities';
import { createAuthStore } from '@nova-integration/ui-shared';
import { APP_ID } from '../lib/capabilities';

export const useAuthStore = createAuthStore({
  appId: APP_ID,
});
